/** Reducer for List certificate request */

import { fromJS } from 'immutable';
import { SET_LIST_SCHOOL_YEAR } from '../actions/schoolYearConst';

export const initialState = {
  listSchoolYear: []
};

const initialImmutableState = fromJS(initialState);

const schoolYear = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LIST_SCHOOL_YEAR:
      state = initialState;
      return state.listSchoolYear.concat(action.school_year);
    default:
      return state;
  }
};

export default schoolYear;
